import React, { Component } from 'react';
import moment from 'moment';
import List from '../components/alert/list';
import FormTabs from '../components/alert/formTabs';
import MessagesTabs from '../components/alert/messagesTabs';
import { toastDisplayed } from '../actions/alert_actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
const Materialize = window.Materialize;

class App extends Component {
  componentDidMount() {
    document.title = 'Alert';
  }
  componentDidUpdate() {
    //check if an attempt to send a notification has been made
    if (this.props.messageAttempt) {
      //check if the notification sent was successful or unsuccessful
      if (this.props.messageSuccess) {
        // if unsuccessful, display error
        Materialize.toast(this.props.messageSuccess, 4000, 'rounded red');
      } else {
        Materialize.toast(`Success!`, 4000, 'rounded green');
      }
      //notify state that the toast was displayed so that it does not display again
      this.props.toastDisplayed();
    }
  }

  render() {
    return (
      <div>
        <div className="row">
          <h5>Alert <span className="flow-text right">{ moment().format("dddd, MMMM Do YYYY") }</span></h5><hr />
          <div className="col s12 m4 l3">
            <List className="list-card"/>
          </div>
          <div className="col s12 m8 l9">
            <FormTabs className="card-panel row col m12 s12 center"/>
            <MessagesTabs className="card-panel col m12 s12 center"/>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    messageAttempt: state.toast.messageAttempt,
    messageSuccess: state.toast.messageSuccess
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    toastDisplayed
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/alert.js